import { setDeepNestedProperty } from '@sales-center/common'
import { FormikErrors } from 'formik'
import { IDateRangeFilter, IFilterSet } from '../typings'
import { isValidMuiDate } from '@sales-center/common'

export function setDateValidationErrors<T>(
  passedDate: IDateRangeFilter<T>,
  errors: FormikErrors<IFilterSet<T>>,
) {
  if (passedDate && passedDate.value) {
    const { start, end, matchType } = passedDate.value
    if (end && !isValidMuiDate(end)) {
      setDeepNestedProperty(
        errors,
        [`filters`, passedDate.propertyName, 'value', 'end'],
        'Invalid date format',
        true,
      )
    }

    if (start && !isValidMuiDate(start)) {
      setDeepNestedProperty(
        errors,
        [`filters`, passedDate.propertyName, 'value', 'start'],
        'Invalid date format',
        true,
      )
    }
    if (matchType === 'bt') {
      if (start && end && start > end) {
        setDeepNestedProperty(
          errors,
          [`filters`, passedDate.propertyName, 'value', 'end'],
          'End date should be always after start date',
          true,
        )
      }
    }
  }
}
